import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

function Template5Overlay({
  formation_header,
  formation,
  nom,
  CIN,
  date,
  publicKey,
  status,
}) {
  // Convert the date string to a Date object
  const originalDate = new Date(date);

  // Calculate the expiration date by adding 3 years
  const expirationDate = new Date(originalDate);
  expirationDate.setFullYear(expirationDate.getFullYear() + 3);

  // Format the original date as "DD-MM-YYYY"
  const formattedDateString = originalDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  // Format the expiration date as "DD-MM-YYYY"
  const formattedExpirationDateString = expirationDate.toLocaleDateString(
    'en-GB',
    {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }
  );

  const qrCodeValue = `${publicKey} - ${status}`;

  return (
    <div className='overlay'>
      <div className='nom4'>
        <h2>{nom}</h2>
      </div>
      <div className='cin4'>
        <h5>{CIN}</h5>
      </div>
      <div className='date4'>
        <h5>{formattedDateString}</h5>
      </div>
      <div className='qr-code-container'>
        <QRCodeSVG value={qrCodeValue} className='qr-code4' />
      </div>
      <div className='validite4'>
        <h5>Certification valable jusqu'au {formattedExpirationDateString}</h5>
      </div>
      <div className='signature4'>
        <img
          src={'/signe.png'}
          alt='Description'
          style={{
            maxWidth: '100%',
            animation: 'rotate360 2s infinite linear',
          }}
        />
      </div>
    </div>
  );
}

export default Template5Overlay;
